import locationCloneComponent from './location.clone.component';

let locationCloneModule = angular.module('locationclone', [])

  .component('locationclone', locationCloneComponent)

  .name;

export default locationCloneModule;





// WEBPACK FOOTER //
// ./client/app/components/location/clone/index.js